import PropTypes from 'prop-types';
import { LOCAL_MAP_OPTIONS } from 'eventbrite_design_system/interactiveMap/constants';

import { EVENT_PROPTYPES } from '../../constants';

// Keep these in sync with the value in InteractiveMapMarkerTooltipMobile.scss
export const BBOX_SEARCH_BTN_PADDING_FROM_HEADER = 16;
export const ACTION_BAR_OFFSET = 68;

// Max zoom is set to slightly less than the default max,
// which lets you get so close that the map is basically useless.
// Defining it in JS is also useful because we can use it to split up cluster
// names when the user can no longer zoom in any longer
export const MAX_ZOOM = 16;

export const MOBILE_MAP_FULL_SCREEN = '#mobilemap';

// Override some of the defaults from EDS
export const SEARCH_MAP_OPTIONS = {
    ...LOCAL_MAP_OPTIONS,
    disableDefaultUI: false,
    fullscreenControl: false,
    scrollwheel: false,
    maxZoom: MAX_ZOOM,
    minZoom: 3,
};

// The map bounds automatically change (without user input) one time upon map initialization
export const INITIAL_MAP_BOUNDS_CHANGE_COUNT = 2;

//TEMPORARY: Hard coded far out zoom level
//to gauruntee all events are
//displayed on the map
// TODO: Come up with better way to determine bounds
//on the map
export const DEFAULT_ZOOM_VALUE = 10;

export const GLOBAL_BBOX = [-180, -90, 180, 90];

export const SEARCH_MAP_BASE_PROPTYPES = {
    events: PropTypes.arrayOf(PropTypes.shape(EVENT_PROPTYPES)),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    width: PropTypes.string,
    countryCode: PropTypes.string,
    googleMapLanguage: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    searchByBBox: PropTypes.func,
    setShouldScroll: PropTypes.func,
};

export const SEARCH_MAP_DESKTOP_MOBILE_PROPTYPES = {
    ...SEARCH_MAP_BASE_PROPTYPES,
    onSearchByBounds: PropTypes.func.isRequired,
    onClickOutsideMapMarker: PropTypes.func.isRequired,
    markers: PropTypes.arrayOf(PropTypes.object),
    propsForInteractiveMap: PropTypes.shape({
        height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
            .isRequired,
        width: PropTypes.string.isRequired,
        language: PropTypes.string,
        region: PropTypes.string,
        center: PropTypes.shape({
            lat: PropTypes.number,
            lng: PropTypes.number,
        }).isRequired,
        zoom: PropTypes.number,
        onChange: PropTypes.func,
        onGoogleApiLoaded: PropTypes.func,
    }).isRequired,
};
